/**
 * The pages a user visited last (per user, in this browser), for the home page's
 * "Recently visited". The router records each page visited; login, error and the home
 * page itself aren't recorded.
 */
const LIMIT = 6;
const SKIP = new Set(["Home", "login", "logout", "Register", "Forgot password", "Reset Password", "TwoFactorAuth"]);

const key = () => `recentPages:${localStorage.getItem("userid") || "guest"}`;

export function recentPages() {
  try {
    const list = JSON.parse(localStorage.getItem(key()) || "[]");
    return Array.isArray(list) ? list : [];
  } catch (e) {
    return [];
  }
}

export function recordPage(route) {
  if (!route || !route.name || SKIP.has(route.name) || String(route.path).startsWith("/error")) return;
  if (!route.matched.some((r) => r.meta && r.meta.authRequired)) return;
  try {
    // A record's page ("View CDV") with the record it shows (its number from the link).
    const query = route.query || {};
    const ref = ["voucher_no", "ap_invoice_no", "doc_num", "invoice_no", "client_code"].map((k) => query[k]).find(Boolean)
      || (route.params && route.params.id);
    const title = `${(route.meta && route.meta.title) || String(route.name)}${ref ? ` · ${ref}` : ""}`;
    const list = recentPages().filter((r) => r.path !== route.fullPath);
    list.unshift({ path: route.fullPath, title, at: new Date().toISOString() });
    localStorage.setItem(key(), JSON.stringify(list.slice(0, LIMIT)));
  } catch (e) {
    // storage unavailable: not recorded
  }
}

export function clearRecentPages() {
  try {
    localStorage.removeItem(key());
  } catch (e) {
    // storage unavailable
  }
}
